import {
	createFileRoute,
	Outlet,
	retainSearchParams,
} from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import { AuthErrorComponent } from '@/shared/auth/components/common/error-component'
import { AuthLayout } from '@/shared/auth/components/common/layout'

const authSearchSchema = z.object({
	// Redirect URL when signed out
	redirect: z.string().optional(),
})

export const Route = createFileRoute('/_auth')({
	validateSearch: zodValidator(authSearchSchema),

	search: {
		middlewares: [retainSearchParams(['redirect'])],
	},

	head: () => ({
		meta: [
			{
				title: 'Login | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RoutePendingComponent,
	errorComponent: AuthErrorComponent,
})

function RouteComponent() {
	return (
		<AuthLayout>
			<Outlet />
		</AuthLayout>
	)
}

function RoutePendingComponent() {
	return (
		<AuthLayout>
			<Outlet />
		</AuthLayout>
	)
}
